import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.scss']
})
export class HeaderTitleComponent implements OnInit {
  @Input({ alias: 'title', required: true }) title: string = '';
  @Input({ alias: 'link', required: true }) link: string = '';
  constructor() { }

  ngOnInit() {
  }

}
